<template>
    <!--Footer  -->
    <div class="row margin-top-30 text-align-center">
        <div class="col-12 margin-top-30">
            <weex-text class="text-color-gray margin-bottom-10">
                © <strong class="cp" v-on:click="openEzCredWebsite"> EzCred  Technologies Pvt Ltd </strong>. All rights reserved
            </weex-text>
        </div>
    </div>
    <!--Footer end -->
</template>

<script>
import { Constants } from "../Constants";

export default {
  name: "Footer",
  components: {},
  data: () => ({}),
  props: {},

  methods: {
    openEzCredWebsite() {
      window.open(Constants.EZCRED_WEBSITE_URL);
    },
  },
  computed: {},
};
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

<style
  scoped
  src="../../assets/style/bootstarp-grid.css"></style>